import React from 'react';
import classNames from 'classnames';

import './SkeletonLoader.scss';

interface SkeletonLoaderProps {
  type: 'line' | 'circle' | 'D-shape';
  height?: number | string;
  width?: number | string;
  maxWidth?: number | string;
  inLine?: boolean;
  autoHeight?: boolean;
  borderRadius?: number;
}

const SkeletonLoader = ({ type, height, width, maxWidth, inLine, autoHeight, borderRadius }: SkeletonLoaderProps) => {
  const getStyleValue = (value?: number | string) => {
    if (typeof value === 'number') {
      return `${value}px`;
    }

    return value;
  };

  return (
    <span
      styleName={classNames({
        loader: true,
        'loader--inline': inLine,
        'loader-16px-line': type === 'line',
        'loader-circle': type === 'circle',
        'loader-d-shape': type === 'D-shape',
        'loader--auto-height': autoHeight,
        'loading-animation': true
      })}
      style={{
        width: getStyleValue(width),
        height: autoHeight ? '100%' : getStyleValue(height),
        maxWidth: getStyleValue(maxWidth),
        paddingRight: inLine ? getStyleValue(width) : undefined,
        borderRadius
      }}
    />
  );
};

export default SkeletonLoader;
